import Smartphones from 'Counterparties/Customers/views/CustomerView/containers/Smartphones'
import Tablets from 'Counterparties/Customers/views/CustomerView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const CustomerView = getCurrentDeviceView(Smartphones, Tablets)

export default CustomerView
